export enum Industries {
    CONVENIENCE_STORES = 'Convenience stores',
    RETAIL = 'Retail',
    DRUGSTORES = 'Drugstores',
    BEAUTY = 'Beauty'
    // CUSTOM = 'Custom',
}
